var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame46({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 14.2999V11.1499C25 9.18976 25 8.20967 24.6185 7.46098C24.283 6.80241 23.7475 6.26698 23.089 5.93142C22.3403 5.54995 21.3602 5.54995 19.4 5.54995H9.6C7.63982 5.54995 6.65972 5.54995 5.91103 5.93142C5.25247 6.26698 4.71703 6.80241 4.38148 7.46098C4 8.20967 4 9.18976 4 11.1499V20.9499C4 22.9101 4 23.8902 4.38148 24.6389C4.71703 25.2975 5.25247 25.8329 5.91103 26.1685C6.65972 26.5499 7.63982 26.5499 9.6 26.5499H15.0833M25 12.5499H4M19.1667 3.21661V7.88328M9.83333 3.21661V7.88328M21.5 25.3833V18.3833M18 21.8833H25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame46);
export default __webpack_public_path__ + "static/media/Frame (46).85d118924a9597d5647fd71415d44b40.svg";
export { ForwardRef as ReactComponent };